import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function materiaisService() {
  const api = useApi()

  function getMateriais(params) {
    return api.query(`${URLS.materiais}${params || ''}`)
  }

  function getMateriaisById(id) {
    return api.query(`${URLS.materiais}${id}/`)
  }

  function postMateriais(data) {
    return api.mutation(`${URLS.materiais}`, 'POST', data)
  }

  function patchMateriais(id, data) {
    return api.mutation(`${URLS.materiais}${id}/`, 'PATCH', data)
  }

  function deleteMaterial(id) {
    return api.mutation(`${URLS.materiais}${id}/`, 'DELETE')
  }

  return {
    getMateriais,
    getMateriaisById,
    postMateriais,
    patchMateriais,
    deleteMaterial,
    ...api,
  }
}
